import { Code2, Rocket, Megaphone, PenTool, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import BrutalCard from "@/components/common/BrutalCard";
import SectionHeading from "@/components/common/SectionHeading";

const SERVICES = [
    {
        icon: Code2,
        title: "Software Solutions",
        copy: "Custom internal tools, dashboards, and integrations engineered for the teams that run your business.",
        bg: "white",
        span: "lg:col-span-7",
    },
    {
        icon: Rocket,
        title: "SaaS Products",
        copy: "From zero-to-one MVPs to scaling platforms — design, engineering, and a growth-ready foundation.",
        bg: "yellow",
        span: "lg:col-span-5",
    },
    {
        icon: Megaphone,
        title: "Digital Marketing",
        copy: "Performance creative, lifecycle, intent-led SEO and founder-led social. Loops, not campaigns.",
        bg: "blue",
        span: "lg:col-span-5",
    },
    {
        icon: PenTool,
        title: "Brand & UI",
        copy: "Distinctive identity systems and product UI that make your brand impossible to ignore.",
        bg: "pink",
        span: "lg:col-span-7",
    },
];

export default function ServicesBento() {
    return (
        <section
            data-testid="services-bento"
            className="border-b-4 border-ink py-24 md:py-32 grain"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
                    <SectionHeading
                        eyebrow="What we do"
                        title="Three studios. One opinionated team."
                        subtitle="We design products, build software, and run growth loops — under one roof so nothing gets lost in handoff."
                    />
                    <Link
                        to="/services"
                        data-testid="services-bento-link"
                        className="font-display font-bold inline-flex items-center gap-1 hover:gap-2 transition-all"
                    >
                        Explore all services <ArrowUpRight size={18} />
                    </Link>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                    {SERVICES.map((s) => {
                        const Icon = s.icon;
                        return (
                            <BrutalCard
                                key={s.title}
                                bg={s.bg}
                                interactive
                                className={s.span}
                                data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                            >
                                <div className="flex items-center justify-between mb-6">
                                    <span className="w-12 h-12 rounded-lg border-2 border-ink bg-white flex items-center justify-center text-ink">
                                        <Icon size={22} />
                                    </span>
                                    <ArrowUpRight size={22} />
                                </div>
                                <h3 className="font-display text-3xl md:text-4xl font-black leading-none">
                                    {s.title}
                                </h3>
                                <p className="mt-4 font-body text-base leading-relaxed">
                                    {s.copy}
                                </p>
                            </BrutalCard>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
